var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{staticClass:"chat-upload",attrs:{"action":"","show-file-list":false,"http-request":_vm.sendImg,"before-upload":_vm.beforeUpload}},[_c('i',{staticClass:"chat iconfont iconfile"})])}
var staticRenderFns = []

export { render, staticRenderFns }